import { font } from '@chegg-ui/theme'
import { normalize } from 'polished'
import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
    ${normalize()}

    body {
        font-family: ${font.family.default};
    }
`



// WEBPACK FOOTER //
// ./src/styled/globalStyles.ts